<template>
  <div
    v-if="option && option.img !== ''"
    id="tip-image-crop"
    class="tip-crop-dialog-wrap"
  >
    <div
      class="tip-crop-dialog"
    >
      <h4 class="tip-crop-dialog-title">
        裁剪图片
      </h4>
      <div class="tip-crop-dialog-content">
        <VueCropper
          ref="cropper"
          :auto-crop="true"
          :auto-crop-height="option.autoCropHeight"
          :auto-crop-width="option.autoCropWidth"
          :can-move="true"
          :can-move-box="true"
          :center-box="option.centerBox"
          :enlarge="2"
          :fixed-box="true"
          :img="option.img"
          :info="false"
          :info-true="true"
          :mode="option.mode"
          :output-size="1"
          :output-type="option.outputType"
          style="height: 400px"
        />
        <div class="tip-crop-dialogbtn-wrap">
          <a
            class="tip-crop-commbtn-style tip-crop-btn-default"
            @click.stop="cropperDoClear()"
          >取消</a>
          <a
            class="tip-crop-commbtn-style tip-crop-btn-primary"
            @click.stop="cropperDoCropAndUpload()"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-cropper/dist/index.css';
import { VueCropper }  from 'vue-cropper';

export default {
  name: 'IndexVue',
  components: {
    VueCropper,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    doClear: {
      type: Function,
      default: null,
      required: false,
    },
    doCropAndUpload: {
      type: Function,
      default: null,
      required: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    cropperDoClear() {
      if (this.doClear) {
        this.doClear();
      }
      setTimeout(() => {
        this.destroy();
      }, 100);
    },
    cropperDoCropAndUpload() {
      this.$refs.cropper.getCropData((data) => {
        if (this.doCropAndUpload) {
          this.doCropAndUpload(data);
        }
        setTimeout(() => {
          this.destroy();
        }, 100);
      });
    },
    destroy() {
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
  },
};
</script>

<style lang="scss">
.tip-crop-dialog-wrap {
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000, $alpha: 0.7);
  display: flex;
  align-items: center;
  .tip-crop-dialog {
    width: 100%;
    background: #fff;
  }

  .tip-crop-dialog-title {
    text-align: center;
    font-size: 0.28rem;
    margin: 0.2rem 0;
  }

  .tip-crop-dialogbtn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.8rem;
    margin: 0.2rem;

    .tip-crop-commbtn-style {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 0.6rem;
      font-size: 0.28rem;
      border-radius: 0.04rem;
    }

    .tip-crop-btn-default {
      color: #ffd571;
      border-width: 0.02rem;
      border-style: solid;
      border-color: #ffd571;
      background: #fff;
    }

    .tip-crop-btn-primary {
      color: #fff;
      background-image: linear-gradient(225deg, #ffd571 0%, #fdc05f 100%);
    }
  }
}
</style>
